<script setup>
import { computed } from 'vue';

const props = defineProps({
  icon: { type: String, default: '' },
  label: { type: String, required: true },
  value: { type: [String, Number, null], default: null },
  disabled: { type: Boolean, default: false },
});

const isEmpty = computed(
  () => props.value == null || props.value === '' || props.value === '-'
);
const displayValue = computed(() =>
  isEmpty.value ? '-' : String(props.value)
);
const labelWithColon = computed(() => `${props.label}:`);
</script>

<template>
  <div
    class="flex items-start gap-3 py-2.5 text-[14px] leading-tight"
    :class="disabled ? 'opacity-50 grayscale' : ''"
  >
    <span
      v-if="icon"
      class="shrink-0 size-5 text-lais-icon"
      :class="icon"
      aria-hidden="true"
    />
    <div class="flex min-w-0 grow flex-wrap items-baseline gap-x-2 gap-y-1">
      <span class="shrink-0 text-lais-text-body font-medium">
        {{ labelWithColon }}
      </span>
      <span
        :class="
          isEmpty
            ? 'text-lais-text-empty'
            : 'text-lais-text-strong font-semibold'
        "
        class="min-w-0 flex-1 break-words"
      >
        <slot>{{ displayValue }}</slot>
      </span>
    </div>
  </div>
</template>
